var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconKeyboardArrowUp = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.47126 17.5424C3.92519 18.1301 3.01786 18.1526 2.44468 17.5927C1.87151 17.0328 1.84953 16.1025 2.3956 15.5148C2.3956 15.5148 10.953 6.44563 10.9778 6.42089C11.5692 5.84131 12.5068 5.86299 13.072 6.46931L21.6027 15.5147C22.1498 16.1014 22.1293 17.0318 21.5571 17.5927C20.9848 18.1536 20.0774 18.1326 19.5304 17.5458L12.2029 9.90828C12.0927 9.79343 11.909 9.7934 11.7988 9.90823L4.47126 17.5424Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconKeyboardArrowUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-keyboard-arrow-up.9ef49182a8ac182725fc488d2177255b.svg";